module.exports = __webpack_public_path__ + "img/hd-phone-icon.e87fcf8a.svg";